
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([36]64|287|560)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
